import React from 'react';

const EyeCrossedIcon = (props) => (
  <svg {...props} viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.90139 3.04017C8.52573 2.87311 9.18874 2.77778 9.88889 2.77778C15.5455 2.77778 18.7778 9 18.7778 9C18.7778 9 18.0409 10.4185 16.6551 11.9009M3.0881 6.1362C1.72463 7.6051 1 9 1 9C1 9 4.23232 15.2222 9.88889 15.2222C10.6018 15.2222 11.2763 15.1234 11.9106 14.9506M9.44445 11.6298C8.48073 11.4681 7.69229 10.7895 7.37396 9.88889M10.3333 6.3702C11.45 6.55755 12.3313 7.43889 12.5187 8.55556M1.88889 1L17.8889 17'
      stroke={props.fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default EyeCrossedIcon;
